import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function BeforeAfterSection() {
  return <section className="w-full bg-white py-20 px-4 border-t border-gray-200" data-id="element-21">
      <div className="max-w-5xl mx-auto" data-id="element-22">
        <div className="text-center mb-12" data-id="element-23">
          <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-24">
            La transformación
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mt-6 leading-tight" data-id="element-25">
            Antes vs Después
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 rounded-2xl overflow-hidden shadow-2xl border border-gray-200" data-id="element-26">
          {/* Antes Column */}
          <div className="bg-red-50 p-8 md:p-12 border-b md:border-b-0 md:border-r border-red-100" data-id="element-27">
            <h3 className="text-2xl font-black text-red-800 mb-8 flex items-center gap-2" data-id="element-28">
              <X className="text-red-600" size={28} strokeWidth={3} data-id="element-29" /> Antes
            </h3>
            <ul className="space-y-6" data-id="element-30">
              {['Pagás 80€ por cada avería pequeña', 'Esperás días al electricista', 'No sabés si te cobran de más', 'Dependés de otra persona en tu casa', 'Cada problema eléctrico te genera ansiedad', 'El dinero se va sin control'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-31">
                  <X className="text-red-500 shrink-0 mt-1" size={20} strokeWidth={3} data-id="element-32" />
                  <span className="text-red-900 font-medium text-lg" data-id="element-33">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Después Column */}
          <div className="bg-blue-50 p-8 md:p-12" data-id="element-34">
            <h3 className="text-2xl font-black text-blue-800 mb-8 flex items-center gap-2" data-id="element-35">
              <Check className="text-blue-600" size={28} strokeWidth={3} data-id="element-36" />{' '}
              Después
            </h3>
            <ul className="space-y-6" data-id="element-37">
              {['Resolvés la mayoría de averías vos mismo', 'Solucionás en 30 minutos lo que antes tardaba días', 'Sabés exactamente qué estás haciendo', 'Sos autónomo en tu propia casa', 'Los problemas eléctricos ya no te preocupan', 'Ahorrás 400€ - 800€ al año'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-38">
                  <Check className="text-blue-600 shrink-0 mt-1" size={20} strokeWidth={3} data-id="element-39" />
                  <span className="text-blue-900 font-bold text-lg" data-id="element-40">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-41">
          <motion.a href="#compra" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block bg-yellow-400 hover:bg-yellow-500 text-black font-black text-lg md:text-xl py-4 px-8 rounded-lg shadow-[0_5px_0_rgb(202,138,4)] hover:shadow-[0_2px_0_rgb(202,138,4)] hover:translate-y-[3px] transition-all uppercase tracking-wide" data-id="element-42">
            ⚡ QUIERO ESTA TRANSFORMACIÓN →
          </motion.a>
        </div>
      </div>
    </section>;
}